import React from 'react';

const ListTableContext = React.createContext({});

export default ListTableContext;
